import React from 'react';
import PropTypes from 'prop-types';

import Box from 'components/atoms/Box/Box';

import { useSubHeaderStyles } from './subHeaderStyles';
import AppBar from 'components/atoms/AppBar/AppBar';

export default function SubHeader(props) {
  const classes = useSubHeaderStyles(props);

  return (
    <AppBar color="transparent" position={props.position}>
      <Box className={classes.box}>{props.children}</Box>
    </AppBar>
  );
}

SubHeader.propTypes = {
  /**
   * The positioning type. The behavior of the different options is described in https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning.
   */
  position: PropTypes.oneOf([
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky',
  ]),
  /**
   * Subheader background image
   */
  backgroundImage: PropTypes.node,
  /**
   * Padding of inside child component
   */
  padding: PropTypes.string,
  /**
   * SubHeader children components
   */
  children: PropTypes.node,
};
